/*
 * Copyright 2021 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2021.03.09 at 13:39
 */
import { ComponentProxy } from '@labor-digital/helferlein';
import { runInAction } from 'mobx';
var BitContext = /** @class */ (function () {
    function BitContext(mount, di, react, binder) {
        this._mount = mount;
        this._di = di;
        this._react = react;
        this._binder = binder;
    }
    Object.defineProperty(BitContext.prototype, "mount", {
        /**
         * Returns the reference of the mount point
         */
        get: function () {
            return this._mount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitContext.prototype, "di", {
        /**
         * Returns the di container instance of the application
         */
        get: function () {
            return this._di;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitContext.prototype, "reactivityProvider", {
        /**
         * Returns the reactivity provider for this bit
         */
        get: function () {
            return this._react;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitContext.prototype, "binder", {
        /**
         * Returns the dom binding service for this bit
         */
        get: function () {
            return this._binder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitContext.prototype, "proxy", {
        /**
         * Returns the instance of the component proxy.
         * The instance is lazy and only created when it was first requested
         */
        get: function () {
            if (!this._proxy) {
                this._proxy = new ComponentProxy(this._mount.bit, function (f) {
                    runInAction(function () { return f(); });
                });
            }
            return this._proxy;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Completely destroys the context instance, by calling the nested destroy methods and unlinking
     * all references for garbage collection
     */
    BitContext.prototype.destroy = function () {
        if (this._proxy) {
            this._proxy.destroy();
        }
        this._binder.destroy();
        this._react.destroy();
        delete this._proxy;
        this._react = null;
        this._binder = null;
        this._di = null;
        this._mount = null;
    };
    return BitContext;
}());
export { BitContext };
//# sourceMappingURL=BitContext.js.map